import firebase from "./firebase";
import FirebaseContext from "../lib/AuthContext";

export { FirebaseContext }

export default firebase;